import React from 'react';

import { Container } from './styles';

const Form: React.FC = ({ children }) => {
  return (
    <Container>
      <>{children}</>
    </Container>
  );
};

export default Form;
